import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgCheckmarkCircleFilled16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4444 12.4444 16 8 16C3.55556 16 0 12.4444 0 8C0 3.55556 3.55556 0 8 0C12.4444 0 16 3.55556 16 8ZM11.3152 6.2265C11.5685 5.91286 11.5196 5.45325 11.206 5.19992C10.8923 4.9466 10.4327 4.99549 10.1794 5.30913L7.10649 9.1137L5.79082 7.67843C5.51839 7.38123 5.05662 7.36115 4.75942 7.63358C4.46222 7.90601 4.44215 8.36779 4.71458 8.66498L6.60335 10.7255C6.74699 10.8822 6.95181 10.9685 7.16429 10.9618C7.37677 10.9552 7.57579 10.8562 7.70937 10.6909L11.3152 6.2265Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkCircleFilled16);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=CheckmarkCircleFilled16.svg.js.map
